import React from 'react';
import CnCardView from './cn-card';
class CnCard extends React.Component {
    constructor(props) {
        super(props);
        this.ref = React.createRef();
    }
    render() {
        return React.createElement(CnCardView, { ref: this.ref, ...this.props });
    }
}
CnCard.displayName = 'CnCard';
export default CnCard;
export { CnCard };
